import OrganisationPageRouter from './OrganisationPageRouter'
export default OrganisationPageRouter